import script from "./StatusDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusDropdown.vue?vue&type=script&setup=true&lang=js"

import "./StatusDropdown.vue?vue&type=style&index=0&id=5f8b21d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8b21d6"]])

export default __exports__